import { ReservationDetails } from "./AYPResultInterface";
import { PrimaryGuest } from "./BookResort";

export interface ReservationDetailsExtended extends ReservationDetails {
    reservationUserFields: any;
    primaryGuest: PrimaryGuest;
    activities: string[];
    reservationID: number;
    reservationConfirmationNumber: string;
    reservationNumber: string;
    cancellationNumber: string;
    transactionDate: string|Date;
    transactionYear?: number;
    cancellationDate: string|Date;
    pointsRequired: number; //should this be pointsApplied? is there a difference?
    pointsApplied: number;
    reservationType: string;
    reservationTypeContent: string;
    canCancel?: boolean;
    disableVoaCancelCapability?: boolean;
};

export interface GetReservationsResult {
    additionalEmails: string[];
    additionalGuests: string[];
    reservationDetails: ReservationDetailsExtended;
};

export interface GetReservationActivity {
    reservations: GetReservationsResult[];
    sortFilter: {
        year: {
            range: number[];
            default: number
        }
    }
}

export enum ReservationType {
    "UPCOMING" = "UPCOMING",
    "PAST" = "PAST",
    "CANCELED" = "CANCELED"
}

export interface GetCountriesResult {
    ID: string;
    Name: string;
    Description: string;
    State: GetCountriesResult[];
    zipCodeRequired: boolean;
};

export const RESERVATION_USER_FIELD_MAPPING: Record<
    string,
    Record<string, string>
> = {
    "PVP Hotel": {
        hotelName: "userField3",
        roomType: "userField4",
    },
    "PVP Cruise": {
        hotelName: "userField6",
    },
};

// export type ReservationSiteType = keyof typeof RESERVATION_USER_FIELD_MAPPING;
